<template>
  <div class="profile-avatar-container">
    <v-avatar color="primary darken-1" size="62">
      <img v-if="currentImage" :src="currentImage" :alt="initials" class="primary" />
      <span v-else class="white--text headline">{{ initials }}</span>
    </v-avatar>

    <v-tooltip left v-if="isEmployeeModuleEnabled && employee">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" @click.stop="isProfilePictureDialogOpen = true" class="mx-2 edit-button" fab dark color="primary">
          <v-icon dark style="font-size: 16px">mdi-pencil</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('title.editAvatar') }}</span>
    </v-tooltip>

    <profile-picture-dialog
      v-if="employee"
      :employee="employee"
      :initials="initials"
      :photoUrl="photoUrl"
      v-model="isProfilePictureDialogOpen"
    ></profile-picture-dialog>
  </div>
</template>

<script>
import ProfilePictureDialog from '@/components/navdrawer/ProfilePictureDialog.vue';
import configMixin from '@/mixins/configMixin';
import { mapState } from "vuex";
import localStorageManager from '../../services/browserStorageService.js';

export default {
  name: 'ProfilePictureAvatar',
  mixins: [configMixin],
  components: {
    ProfilePictureDialog,
  },
  props: {
    employee: Object,
    photoUrl: String,
    initials: String,
  },
  data() {
    return {
      isProfilePictureDialogOpen: false,
      localStorageImage: localStorageManager.getEmployeeAvatar(),
    };
  },
  computed: {
    ...mapState({ isConnected: (state) => state.isConnected, }),

    isEmployeeModuleEnabled() {
      return this.getModuleConfig('Employee');
    },
    currentImage() {
      if (this.localStorageImage === 'deleted') return null;
      if (this.localStorageImage) return this.localStorageImage;
      if (this.photoUrl && !this.profilePictureDeleted && this.isConnected) return this.photoUrl;
      return null;
    },
  },

};
</script>

<style scoped>

.profile-avatar-container {
  position: relative;
  display: inline-block;
}

.edit-button {
  position: absolute;
  bottom: -5px;
  left: 30px;
  width: 25px;
  height: 25px;
  padding: 0;
}
</style>
